import { environment } from '@env/environment';

import { tap } from 'rxjs/operators';
import { Observable } from 'rxjs';

import { provideServiceWorker } from '@angular/service-worker';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { provideRouter, withRouterConfig } from '@angular/router';
import { provideHttpClient, withInterceptorsFromDi, withXhr } from '@angular/common/http';

import { inject, provideAppInitializer, provideZoneChangeDetection } from '@angular/core';

import { Store } from '@ngxs/store';

import { AppUpdate } from '@shared/services/app-update.service';
import { RootService } from '@shared/services/root.service';
import { GetChatPrefs } from '@shared/states/prefs.actions';
import { AnalyticsMediator } from '@shared/services/analytics-mediator.service';
import { InitAuthentication } from '@shared/states/auth.actions';

import { zefRouterConfig, ZefRoutes } from '../zef.routing';

function authInitializer(store: Store, am: AnalyticsMediator): Observable<void> {
  if (environment.debug) {
    (window as any)['ngxs'] = store;
  }

  return store.dispatch(new InitAuthentication()).pipe(tap(() => am.initialize()));
}

function chatInitializer(store: Store): Observable<void> {
  return store.dispatch(new GetChatPrefs());
}

export const rootProviders = [
  provideZoneChangeDetection(),
  provideAnimationsAsync(),
  provideHttpClient(withXhr(), withInterceptorsFromDi()),
  provideRouter(ZefRoutes, withRouterConfig(zefRouterConfig)),
  provideServiceWorker('safety-worker.js', {
    enabled: environment.production,
    registrationStrategy: 'registerImmediately',
  }),
];

export const appInitializerProviders = [
  provideAppInitializer(() => authInitializer(inject(Store), inject(AnalyticsMediator))),
  provideAppInitializer(() => chatInitializer(inject(Store))),
  provideAppInitializer(() => {
    inject(AppUpdate);
    inject(RootService);
  }),
];
